import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatePipe } from 'bookraw/shared/pipes/date.pipe';
import { SlugifyPipe } from 'bookraw/shared/pipes/slugify.pipe';
import { StatisticsTimePipe } from 'bookraw/shared/pipes/statistics-time.pipe';
import { DecimalPipe } from 'bookraw/shared/pipes/decimal.pipe';

const pipes = [
  DatePipe,
  SlugifyPipe,
  StatisticsTimePipe,
  DecimalPipe,
];

@NgModule({
  imports: [
    CommonModule
  ],
  declarations: pipes,
  exports: pipes
})
export class BookrawSharedPipesModule {
}
